<div class="subBlockContent" id="confirmProduct">
  <child-header [title]="title" (closeEvent)="close()"></child-header>
  <loading-screen *ngIf="!loadContent" backDropWidth="1200" [isScrolled]="true" [showBlurTable]="false"
    (currentLoadingStatus)="onLoading($event)">
  </loading-screen>

  <div #ParentWrapper class="inner-subBlock-wrapper child-body">

    <!-- <div class="page-title-wrapper">
            <div class="title blade-title-font">
                {{title}}
            </div>
            <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div> -->
    <div class="pannel-outter-wrapper">

      <!--Software-->
      <ng-container *ngIf="productType==='Software'">

        <div class="wrapper center-block panel-wrapper-margin">
          <div class="panel-group" id="accordionCSPSoftware" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingCSPSoftware">
                <div class="row">
                  <div class="listpart col-md-6">
                    <mat-form-field>
                      <input class="perpetualmpn" type="text" name="matmpnid" placeholder="Select / Enter New MPN ID"
                        aria-label="Number" #trigger="matAutocompleteTrigger" integerOnly
                        [(ngModel)]="softwareMpnIdSelect" matInput [matAutocomplete]="auto"
                        [formControl]="softwareMPNControl">
                      <mat-spinner mode="indeterminate" style="right: 20px;" class="spinnerPosition" diameter="15"
                        *ngIf="isCheck">
                      </mat-spinner>
                      <i class="material-icons align-arrow-right"
                        (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option [value]="NoMPNText">
                          {{NoMPNText}}
                        </mat-option>
                        <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                          {{mpn}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </div>

                <div id="collapsePendingCSPSoftware" class="panel-collapse collapse in show" role="tabpanel"
                  aria-labelledby="headingSoftware">
                  <div class="panel-body">
                    <div class="panel-content">
                      <div class="mTable">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col" style="width: 5%;"></th>
                              <th scope="col" style="width: 20%;">STOCK CODE</th>
                              <th scope="col" style="width: 35%;">STOCK DESCRIPTION</th>
                              <th scope="col" class="align-center" style="width: 20%;">
                                EXPIRY DATE</th>
                              <th scope="col" class="align-center" style="width: 10%;">QTY
                              </th>
                              <th scope="col" class="align-center" style="width: 10%">
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let pendingItem of softwareSubscriptionPendingList;index as i;">
                              <tr>
                                <!-- <tr *ngFor="let pendingItem of softwareSubscriptionPendingList;index as i;"> -->
                                <td class="align-center align-top">
                                  &nbsp;
                                </td>
                                <td class="align-left push-right">
                                  {{pendingItem?.stockCode}}
                                <ng-container  *ngIf="pendingItem.lineType == 'SOFT'">
                                  <div class="result-info">
                                    <div class="produc-secondary-title-wrapper pt-2">
                                      <div>
                                        <span
                                          (click)="changeBillingFrequencyForSoftware($event.option.value,pendingItem)">BILLING
                                          FREQUENCY:&nbsp;</span>
                                      </div>

                                      <mat-form-field class="full-width" style="padding-left: 0px;">
                                        <input type="text" placeholder="Change Billing Frequency to"
                                          aria-label="Number" #trigger="matAutocompleteTrigger"
                                          matInput [matAutocomplete]="auto">
                                        <i class="material-icons align-arrow-right"
                                          (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                                        <mat-autocomplete #auto="matAutocomplete"
                                          (optionSelected)="changeBillingFrequencyForSoftware($event.option.value,pendingItem)">
                                          <ng-container *ngIf="pendingItem.supportedBillingCycleTypes">
                                            <mat-option *ngFor="let billingcycle of 
                                                pendingItem.supportedBillingCycleTypes" [value]="billingcycle">
                                              {{billingcycle}}
                                            </mat-option>
                                          </ng-container>
                                        </mat-autocomplete>
                                      </mat-form-field>
                                      <span style="position:relative;">
                                        <mat-spinner mode="indeterminate" class="billingfreq" diameter="15"
                                          *ngIf="isBillingFreq">
                                        </mat-spinner>
                                      </span>

                                    </div>
                                  </div>
                                </ng-container>
                                </td>
                                <td>
                                  <span class="description">{{pendingItem?.description}}</span>
                                </td>
                                <td class="align-center align-top">
                                  &nbsp;
                                </td>
                                <td class="align-center align-top">
                                  {{pendingItem?.quantity}}
                                </td>
                                <td class="align-center align-top">
                                  <button class="button button-red button-mid"
                                    (click)="removeSoftwareSubscriptionPendingList(i)">Remove</button>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                        <div class="row " *ngIf="purchase == 'Y'">                         
                           <!-- <div *ngIf="this.commonService.getIsDevOps()"  class="col button-center ">
                            <button 
                              class="button button-red button-large button-center-right"
                              (click)="downloadExcelSoftwareConfirmProducts()"
                            >
                              Download Quotes
                            </button>
                          </div> -->
                          <div class="col button-center ">
                            <button class="button button-red button-large button-center-right"
                            (click)="confirmSoftwareSubscription()"
                            [disabled]="!softwareSubscriptionPendingList?.length||!checkSoftwareMpnId||!checkBillingFrequency || (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)"
                            [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                            matTooltip="Requires Purchasing Permissions"
                          >Confirm All</button>
                          </div>
                       
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </ng-container>

      <!-- Azure RI -->
      <ng-container *ngIf="productType==='Reservations'">

        <div class="wrapper center-block panel-wrapper-margin">
          <div class="panel-group" id="accordionReservedInstance" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingAzureri">
                <div class="row">
                  <div class="listpart col-md-6">
                    <mat-form-field>
                      <input class="perpetualmpn" type="text" name="matmpnid" placeholder="Select / Enter New MPN ID"
                        aria-label="Number" integerOnly #trigger="matAutocompleteTrigger"
                        [(ngModel)]="azureRiMpnIdSelect" matInput [matAutocomplete]="auto"
                        [formControl]="azureRiMPNControl">
                      <mat-spinner mode="indeterminate" style="right: 20px;" class="spinnerPosition" diameter="15"
                        *ngIf="isAzureRiCheck">
                      </mat-spinner>
                      <i class="material-icons align-arrow-right"
                        (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option [value]="NoMPNText">
                          {{NoMPNText}}
                        </mat-option>
                        <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                          {{mpn}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </div>

                <div id="collapsePendingReservedInstance" class="panel-collapse collapse in show" role="tabpanel"
                  aria-labelledby="headingAzureri">
                  <div class="panel-body">
                    <div class="panel-content">
                      <div class="mTable">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col" style="width: 5%;"></th>
                              <th scope="col" style="width: 20%;">STOCK CODE</th>
                              <th scope="col" style="width: 35%;">STOCK DESCRIPTION</th>
                              <th scope="col" class="align-center" style="width: 20%;">
                                EXPIRY DATE</th>
                              <th scope="col" class="align-center" style="width: 10%;">QTY
                              </th>
                              <th scope="col" class="align-center" style="width: 10%">
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let pendingItem of azureRIItemsPendingList;index as i">
                              <tr>
                                <td class="align-center align-top">
                                  &nbsp;
                                </td>
                                <td class="align-left push-right">
                                  {{pendingItem?.stockCode}}
                                </td>
                                <td>
                                  <span class="description">{{pendingItem?.description}}</span>
                                </td>
                                <td class="align-center align-top">
                                  &nbsp;
                                </td>
                                <td class="align-center align-top">
                                  {{pendingItem?.quantity}}
                                </td>
                                <td class="align-center align-top">
                                  <button class="button button-red button-mid" (click)="removeAzureRIItemsPending(i)">
                                    Remove</button>
                                </td>
                              </tr>
                            </ng-container>

                          </tbody>
                        </table>
                        <div class="col align-center confirmbtn" *ngIf="purchase == 'Y'">
                        <!--   <div class="col button-center ">
                            <button
                              class="button button-red button-large button-center-right"
                              (click)="downloadExcelSubConfirmProducts()"
                            >
                              Download Quotes
                            </button>
                          </div> -->
                          <button
                            class="button button-red button-large btn-long"
                            (click)="confirmAzureRiList()"
                            [disabled]="!azureRIItemsPendingList?.length || !checkAzureRiMpnId || (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)"
                            [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                            matTooltip="Requires Purchasing Permissions"
                          >Confirm All</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </ng-container>

      <!-- Subscription -->
      <ng-container *ngIf="productType==='OnlineService' || productType==='Azure'">

        <div class="wrapper center-block panel-wrapper-margin">
          <div class="panel-group" id="accordionSubscription" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingSubscription">
                <div id="collapseSubscription" class="panel-collapse collapse in show" role="tabpanel"
                  aria-labelledby="headingSubscription">
                  <div class="panel-body">
                    <div class="panel-content">
                      <div class="inner-subBlock-content">
                        <div>
                            <table class="table display-block">
                              <thead>
                                <tr>
                                  <th scope="col" class="pending-description-col" style="width: 60%">PRODUCT</th>
                                  <th scope="col" class="align-center" style="width: 5%">QTY</th>
                                  <th scope="col" class="align-right" style="padding: 0.75rem 0 0.75rem 0; width: 10%">PRICE</th>
                                  <th scope="col" class="align-right" style="padding: 0.75rem 0 0 0; width: 5%"></th>
                                  <th scope="col" class="align-right" style="padding: 0.75rem 0 0.75rem 0; width: 10%">TOTAL</th>
                                  <th scope="col" class="align-right" style="padding: 0.75rem 0 0 0; width: 5%"></th>
                                  <!-- <th scope="col" class="align-center" style="width: 10%">STATUS</th> -->
                                  <th scope="col" style="width: 5%"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let sub of subscriptionItemsPendingList;index as i">
                                  <tr class="pending-grey-row">
                                    <td style="padding-left: 20px;" class="position-relative">

                                      <div class="description" style="white-space: nowrap;">
                                        <span class="red-bold">{{sub?.stockCode}}</span>
                                      </div>

                                      <div class="produc-secondary-title-wrapper pt-2" style="font-size: 12px; color: grey;">
                                        {{sub?.description}}
                                        <span *ngIf="sub.isAddon" class="nce">ADD-ON</span>
                                      </div>

                                      <div class="result-info">


                                        <!-- term, billing freq -->
                                        <div *ngIf="sub.chargeType == 'NCE'" class="row produc-secondary-title-wrapper pt-2" style="margin-right: unset; margin-left: unset; width: 250%">
                                          <div style="width: 15%">
                                            <!-- <span>TERM:&nbsp;&nbsp;&nbsp;</span> -->
                                            <mat-form-field style="padding-left: 0px; width: 80%;">
                                              <input matInput type="text" aria-label="term" placeholder="Term" matInput #trigger="matAutocompleteTrigger"
                                                [value]="commonService.CSPTermMapping(sub.term)" [matAutocomplete]="auto">
                                              <i class="material-icons align-arrow-right"
                                                (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                                              <mat-autocomplete #auto="matAutocomplete"
                                                (optionSelected)="changeTerm($event.option.value,sub, i)">
  
                                                <ng-container *ngIf="sub.supportedTermsForChange">
                                                  <ng-container>
                                                    <mat-option *ngFor="let term of 
                                                    sub.supportedTermsForChange" [value]="term" [disabled]="term == sub?.term">
                                                      {{commonService.CSPTermMapping(term)}}
                                                    </mat-option>
                                                  </ng-container>
                                                </ng-container>
  
                                              </mat-autocomplete>
                                            </mat-form-field>
                                          </div>

                                          <div style="width: 15%">
                                            <!-- <span>BILLING FREQUENCY:&nbsp;&nbsp;&nbsp;</span> -->
                                            <mat-form-field style="padding-left: 0px; width: 80%;">
                                              <input type="text" aria-label="bf" placeholder="Billing Frequency" matInput #trigger="matAutocompleteTrigger"
                                                [value]="commonService.CSPBFMapping(sub.billingFrequency)" [matAutocomplete]="auto2">
                                              <i class="material-icons align-arrow-right"
                                                (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                                              <mat-autocomplete #auto2="matAutocomplete"
                                                (optionSelected)="changeBillingFrequency($event.option.value,sub, i)">
  
  
                                                <ng-container *ngIf="sub.supportedBillingCycleTypes">
                                                  <ng-container>
                                                    <mat-option *ngFor="let billingcycle of 
                                                    sub.supportedBillingCycleTypes" [value]="billingcycle" [disabled]="billingcycle == sub?.billingFrequency">
                                                      {{commonService.CSPBFMapping(billingcycle)}}
                                                    </mat-option>
                                                  </ng-container>
                                                </ng-container>
  
                                              </mat-autocomplete>
                                            </mat-form-field>
                                          </div>

                                          <div style="width: 15%">
                                            <div>
                                              <span style="display: block; font-size: 10px; color: grey;">Segment:&nbsp;&nbsp;&nbsp;</span>
                                            </div>
                                            <div>
                                              <span>{{sub?.qualification}}</span>
                                            </div>
                                            
                                          </div>
                                        </div>


                                        <div class="produc-secondary-title-wrapper" style="display: flex; width: 250%;">
                                          <div style="width: 15%">
                                            <!-- <span>END DATE ALIGNMENT:&nbsp;&nbsp;&nbsp;</span> -->
                                            <mat-form-field style="padding-left: 0px; width: 80%;">
                                              <mat-select [formControl]="getCustomEndDateTypeControlByIndex(i)" placeholder="End Date Alignment"
                                                class="customDropdwon" bindValue="value" bindLabel="displayText"
                                                (selectionChange)="changeEndDateType($event.value, tempRef, sub.stockCode, i)">
                                                <mat-option *ngFor="let type of customEndDateTypeList" [value]="type">
                                                  {{ type }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>


                                          </div>

                                          <div style="width: 15%">
                                            <!-- <span (click)="enablePendingAddonEditMpn(sub)">MPN:&nbsp;&nbsp;&nbsp;</span> -->
                                            <span class="cursor-pointer red-bold"
                                              (click)="enablePendingAddonEditMpn(sub)" *ngIf="!sub.editMPN">{{sub?.mpn}}&nbsp;</span>
                                            <span class="cursor-pointer red-bold" *ngIf="sub.editMPN">
                                              <mat-form-field style="width: 80%; margin-right: 20px;">
                                                <input type="text" name="matmpnid"
                                                  placeholder="Select / Enter New MPN ID"
                                                  aria-label="Number" [(ngModel)]="sub.mpn" integerOnly
                                                  (blur)="onPendingMPNIdChang(sub)" matInput
                                                  #triggerAddon="matAutocompleteTrigger" [matAutocomplete]="auto3">
                                                <i class="material-icons align-arrow-right"
                                                  (click)="showAutoCompletePanel(triggerAddon);$event.stopPropagation()">arrow_drop_down</i>
                                                <mat-autocomplete #auto3="matAutocomplete">
                                                  <mat-option [value]="NoMPNText">
                                                    {{NoMPNText}}
                                                  </mat-option>
                                                  <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                                                    {{mpn}}
                                                  </mat-option>
                                                </mat-autocomplete>
                                                <mat-icon matSuffix class="editmpnidicon" placement="bottom"
                                                  matTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-AU/ or call the Microsoft Partner Hotline on 13 20 58 (Options 2,5,1)">
                                                  info</mat-icon>
                                              </mat-form-field>
                                            </span>
                                          </div>

                                          <div class="produc-secondary-title-wrapper pt-2" *ngIf="productType==='Azure'">
                                            <span>DESC:&nbsp;</span>
                                            <span style="padding-left: 5px;">
                                              <input type="text" class="input" maxlength="30"
                                                [(ngModel)]="sub.subscriptionDescription"
                                                (input)="commonService.subscription_customer_ref_validation($event)">
                                            </span>
                                          </div>

                                          <div class="row produc-secondary-title-wrapper pt-2"
                                            *ngIf="sub?.stockGroup == '85CU'" style="margin-left: 35px;">
                                            <span style="position:relative;top:3px">OWNER EMAIL:&nbsp;</span>
                                            <span style="padding-left: 15px;">
                                              <input type="text" class="input" maxlength="50"
                                                [(ngModel)]="sub.ownerEmail"
                                                (blur)="checkSubscriptionOwnerEmailStatus(sub)" required>
                                            </span>
                                            <span>
                                              <mat-spinner *ngIf="showEmailloading" mode="indeterminate" class="circle"
                                                diameter="20"></mat-spinner>
                                            </span>
                                          </div>
                                        </div>

                                        <div>
                                          <div class="custom-end-date"
                                          *ngIf="getCustomEndDateTypeControlByIndex(i)?.value !== 'Default'">
                                          <div class="searchIcon">
                                            <img src="../images/new_ui/date.png">
                                          </div>
                                          <input #customEndAateInput class="custom-end-date-input" type="text"
                                            placeholder="Date" mame="shippingDate" ngbDatepicker #dA="ngbDatepicker"
                                            [formControl]="getCustomEndDateControlByIndex(i)" (click)="openRightPanel(tempRef, i)" readonly>
                                          <mat-icon matSuffix class="editmpnidicon" placement="bottom"
                                            matTooltip="You can co-term your new NCE subscription to the same end date as any other non-trial NCE subscription already present on the tenant or align to calendar month.">
                                            info</mat-icon>

                                          <!-- ViewSubEndDate hover -->
                                          <span class="produc-secondary-title-wrapper"
                                            *ngIf="getCustomEndDateTypeControlByIndex(i)?.value == 'Co-Term'">
                                            <a style="cursor: pointer;" placement="bottom"
                                              (click)="openRightPanel(tempRef, i)">
                                              <span class="small-logo-wrapper">
                                                <img style="width: 16px; height: 16px;" src="../images/new_ui/clock-red.svg">
                                              </span>
                                              View subscription end-dates
                                            </a>
                                          </span>
                                          <!-- view end dates right panel -->

                                          </div>
                                          <ng-template #tempRef let-index="index">
                                            <div id="sidecontainer">
                                              <child-header title="View subscription end-dates"
                                                (closeEvent)="sidenavService.panel.close()"></child-header>
                                              <div class="child-body">
                                                <p class="ml-3 view-end-date-title">This end date alignment must match
                                                  with either one of the below subscriptions expiry date</p>
                                                <ng-container *ngFor="let s of subsForViewEndDates">
                                                  <div style="font-size: 11px; margin-left: 30px; cursor: pointer;"
                                                    (click)="assignEndDate(s.baseSubscription.out_expiry_date, sub.stockCode)">
                                                    <span>Expiry Date: <span class="exp-date">{{
                                                        s.baseSubscription?.out_expiry_date }}</span></span><br />
                                                    <span>{{ s.baseSubscription?.out_sub_description }}</span><br />
                                                    <span>{{ s.baseSubscription?.out_stk_description }}</span><br />
                                                    <span>SKU: {{ s.baseSubscription?.out_stock_code }}</span><br />
                                                  </div>
                                                  <br />
                                                </ng-container>
                                              </div>
                                            </div>
                                          </ng-template>
                                        </div>
                                      </div>
                                    </td>
                                    <!-- <td class="align-center">
                                      <input class="align-center input-wrapper input-wrapper-small" disabled type="text"
                                        value="0">
                                    </td> -->
                                    <td class="align-right">
                                      <input class="align-center input-wrapper input-wrapper-small" type="text" style="text-align: right; padding: 7px;"
                                        [(ngModel)]="sub.quantity" (keypress)="_keyPress($event)" type="text" (blur)="changeQty(sub)">
                                    </td>
                                    <td class="align-right" style="padding: 0.75rem 0 0 0;">
                                      {{ sub.needToAdjustPrice() ? sub?.itemPriceByBF : sub?.itemPrice }}
                                      <!-- <span *ngIf="sub?.term != 'P1M' && sub?.billingFrequency == '1'">/mth</span>
                                      <span *ngIf="sub?.term != 'P1Y' && sub?.billingFrequency == 'Y'">/yr</span> -->
                                    </td>
                                    <td class="align-left" style="padding: 0.75rem 0 0 5px;">
                                      {{ sub?.itemPriceByBFUnit }}
                                      <!-- <span *ngIf="sub?.term != 'P1M' && sub?.billingFrequency == '1'">/mth</span>
                                      <span *ngIf="sub?.term != 'P1Y' && sub?.billingFrequency == 'Y'">/yr</span> -->
                                    </td>

                                    <td class="align-right" style="padding: 0.75rem 0 0 0;">
                                      {{sub?.totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}
                                    </td>
                                    <td class="align-left" style="padding: 0.75rem 0 0 5px;">
                                      {{ sub?.itemPriceByBFUnit }}
                                    </td>
                                    <!-- <td class="align-center statustext">Pending Confirm</td> -->
                                    <td class="align-center vertical-align-mid">
                                      <span id="delete-icon" class="basic-icon delete-icon"
                                        (click)="removeSubscriptionPendingItem(i)" matTooltip="Remove"
                                        placement="bottom"></span>
                                    </td>
                                  </tr>
                                </ng-container>
                              </tbody>
                              <tfoot>
                                <div class="row totalPrice-wrapper">
                                  <div class="col align-center" *ngIf=" pendingTotal !=0 ">
                                    <span><b>Pending Total (Ex GST) </b>
                                      <span class="pendingTotal ">{{ totalPriceChange |
                                        currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                                  </div>
                                  <div class="col align-center " *ngIf="pendingTotal==0 ">
                                    <span>
                                      <b>Pending Total (Ex GST)</b>
                                      <span class="pendingTotal ">
                                        {{ 0 | currency:'AUD':'symbol-narrow':'.2-2'}}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </tfoot>
                            </table>
                          <div class="row ">
                            <div *ngIf="this.commonService.getIsDevOps()" class="col button-center ">
                              <button 
                                class="button button-red button-large button-center-right"
                                (click)="downloadExcelSubConfirmProducts()"
                              >
                                Download Quotes
                              </button>
                            </div>
                            <div class="col button-center ">
                              <button class="button button-red button-large button-center-right"
                                [disabled]="!subscriptionItemsPendingList?.length ||
                                  !checkMpnId ||
                                  (isToCheckOwnerEmail && !checkEmail) ||
                                  !checkBillingFrequency ||
                                  !isEveryCustomDateValid() ||
                                  (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)
                                "
                                (click)="confirmSubscription()"
                                [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                                matTooltip="Requires Purchasing Permissions"
                              >Confirm All</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </ng-container>
    </div>

  </div>
</div>